var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSend01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7786 8.10642L15.5574 18.3277L18.6682 26.3269L25.7786 8.10642ZM13.6718 16.4421L23.893 6.2208L5.67251 13.3312L13.6718 16.4421ZM27.5295 1.96557C27.7738 1.89462 28.2651 1.76713 28.7928 1.94342C29.389 2.14259 29.8568 2.61046 30.056 3.20666C30.2323 3.73435 30.1048 4.22563 30.0339 4.46988C29.9565 4.73605 29.8327 5.05328 29.7084 5.37155L20.8852 27.9811C20.7464 28.3368 20.612 28.6814 20.4805 28.9474C20.3669 29.1772 20.114 29.6656 19.5891 29.9383C19.0104 30.2389 18.3214 30.2385 17.743 29.9372C17.2185 29.6639 16.9662 29.1752 16.8528 28.9452C16.7216 28.6791 16.5876 28.3344 16.4492 27.9785L12.9693 19.0301L4.06801 15.5685C4.05232 15.5624 4.03664 15.5563 4.02099 15.5502C3.66505 15.4118 3.32032 15.2778 3.05419 15.1466C2.82425 15.0333 2.3355 14.7809 2.06224 14.2564C1.76089 13.678 1.76048 12.989 2.06115 12.4103C2.3338 11.8855 2.82225 11.6326 3.05206 11.5189C3.31803 11.3874 3.6626 11.253 4.01839 11.1142C4.03403 11.1081 4.0497 11.102 4.06538 11.0959L26.6279 2.29101C26.9461 2.16674 27.2634 2.04289 27.5295 1.96557Z",
    fill: "#212529"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend01);
export default __webpack_public_path__ + "static/media/send-01.680ac383852e0625e4f50b1a2ab0d141.svg";
export { ForwardRef as ReactComponent };